const REMEMBERED_IDENTITY_KEY = "clikkle.accounts.rememberedIdentity";

function safeParse(value) {
  try { return JSON.parse(value || "null"); } catch { return null; }
}

export function normalizeIdentity(user = {}, fallbackEmail = "") {
  const fullName = [user.firstName, user.lastName].filter(Boolean).join(" ").trim();
  const email = user.email || fallbackEmail || "";
  const username = user.username || (email.includes("@") ? email.split("@")[0] : email);
  const displayName = user.name || user.fullName || user.displayName || fullName || username || "Clikkle user";
  const avatar = user.profilePicture || user.imageUrl || user.imageURL || user.avatar || user.photo || "";
  return { id: user._id || user.id || "", displayName, email, username, avatar, rememberedAt: Date.now() };
}

export function rememberIdentity(user, fallbackEmail) {
  const identity = normalizeIdentity(user, fallbackEmail);
  if (identity.email || identity.username) localStorage.setItem(REMEMBERED_IDENTITY_KEY, JSON.stringify(identity));
  return identity;
}

export function getRememberedIdentity() {
  const identity = safeParse(localStorage.getItem(REMEMBERED_IDENTITY_KEY));
  if (!identity || (!identity.email && !identity.username)) return null;
  return identity;
}

export function clearRememberedIdentity() {
  localStorage.removeItem(REMEMBERED_IDENTITY_KEY);
  localStorage.removeItem("formData");
}

export function identityUsername(identity) {
  if (!identity) return "";
  return identity.username || (identity.email || "").split("@")[0];
}

export { REMEMBERED_IDENTITY_KEY };
